<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="4">
        <el-button
          icon="el-icon-plus"
          type="primary"
          @click="handleEdit(edit, null)"
        >
          新增酒店
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="20">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="" class="pr-10">
            <el-select
              v-model="queryForm.branchId"
              clearable
              placeholder="门店"
            >
              <el-option
                v-for="item in branchList"
                :key="item.branchId"
                :label="item.title"
                :value="item.branchId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" class="pr-10">
            <el-select v-model="queryForm.step" placeholder="状态">
              <el-option
                v-for="item in stepList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="关键词(匹配标题)"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="门店"
        prop="branch.title"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="封面" prop="title" width="148px">
        <template #default="{ row }">
          <img :src="row.basic.avatar" class="big-avatar" />
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="开业日期"
        prop="basic.openDate"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="电话"
        prop="basic.tel"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="地址"
        prop="basic.address"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="标签"
        prop="basic.tagList"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="状态">
        <template #default="{ row }">
          <el-tag>{{ row.step == 1 ? '未上架' : '已上架' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleEdit(edit, row)">
            编辑
          </el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { findHotelList, removeHotel } from '@/api/room'
import { getAllBranchs } from '@/api/branch'
import Edit from './edit.vue'
import { reactive, ref, getCurrentInstance } from 'vue'

export default {
  name: 'HotelIndex',
  components: { Edit },
  setup() {
    const { proxy } = getCurrentInstance()
    const list = reactive([])
    const listLoading = ref(true)
    const layout = 'total, sizes, prev, pager, next, jumper'
    const total = ref(0)
    const branchList = reactive([])
    const queryForm = reactive({
      branchId: '',
      keyword: '',
      step: '',
      page: 1,
      size: 10,
    })
    const stepList = [
      {
        label: '未上架',
        value: 1,
      },
      {
        label: '已上架',
        value: 2,
      },
    ]
    const edit = ref(null)
    const fetchData = async () => {
      listLoading.value = true
      const data = Object.assign({}, queryForm)
      const { list: list1, total: total1 } = await findHotelList(data)
      list.length = 0
      list.push(...list1)
      total.value = total1
      listLoading.value = false
    }
    const queryData = () => {
      fetchData()
    }
    //添加和编辑
    const handleEdit = (edit, row) => {
      edit.showEdit(row)
    }
    const getAllBranchList = async () => {
      const res = await getAllBranchs({})
      if (!res) return
      branchList.length = 0
      branchList.push(...res)
    }
    //分页
    const handleSizeChange = (val) => {
      queryForm.size = val
      fetchData()
    }
    const handleCurrentChange = (val) => {
      queryForm.page = val
      fetchData()
    }
    const handleDelete = (row) => {
      proxy.$baseConfirm(
        `你确定要删除酒店：${row.title} 吗`,
        null,
        async () => {
          await removeHotel({ hotelId: row.hotelId })
          proxy.$baseMessage(
            `删除酒店成功`,
            'success',
            false,
            'vab-hey-message-success'
          )
          queryData()
        }
      )
    }
    //拉取数据
    getAllBranchList()
    queryData()
    return {
      list,
      listLoading,
      layout,
      total,
      queryForm,
      moment,
      edit,
      stepList,
      branchList,
      fetchData,
      queryData,
      handleEdit,
      handleDelete,
      handleSizeChange,
      handleCurrentChange,
    }
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
